import React from 'react';
import imgSmile from '../../assets/winking-face.png';

export const IconSmile = () => {
    return <img src={imgSmile} alt="winking-face"/>
}
